import { AbandonReason, FunnelStep, ListedStatus, PaymentMethodGroup } from '../../hooks/abandoned-cart'

export const STATUS_LABELS: Record<ListedStatus, string> = {
  never: 'Não compraram',
  returned: 'Compraram, voltaram e não concluíram',
  refunded: 'Compra devolvida',
  refunded_retried: 'Devolveram e tentaram de novo',
}

export const REASON_LABELS: Record<AbandonReason, string> = {
  left_before_payment: 'Saiu antes do pagamento',
  left_payment_screen: 'Saiu na tela de pagamento',
  left_after_method: 'Escolheu o meio de pagamento e saiu',
  payment_pending: 'Pagamento iniciado e não confirmado',
  pix_unpaid: 'Pix gerado e não pago',
  pix_not_generated: 'Pix não gerado',
  nupay_unfinished: 'NuPay não concluído',
  card_antifraud: 'Cartão negado na análise de segurança',
  card_declined: 'Cartão recusado pelo banco',
  card_invalid_data: 'Dados do cartão inválidos',
  refunded: 'Compra devolvida',
  unknown: 'Não identificado',
}

export const METHOD_LABELS: Record<PaymentMethodGroup, string> = {
  pix: 'Pix',
  card: 'Cartão',
  nupay: 'NuPay',
  apple_pay: 'Apple Pay',
  google_pay: 'Google Pay',
  picpay: 'PicPay',
  other: 'Outro',
  none: 'Não escolheu',
}

export const STEP_LABELS: Record<FunnelStep, string> = {
  started: 'Iniciaram a compra',
  added_to_cart: 'Escolheram ingresso',
  checkout: 'Chegaram ao checkout',
  payment_screen: 'Chegaram à tela de pagamento',
  method_selected: 'Escolheram o meio de pagamento',
  payment_submitted: 'Enviaram o pagamento',
  paid: 'Pagaram',
}

export const formatInteger = (value: number): string => value.toLocaleString('pt-BR')

export const formatCents = (cents: number): string =>
  (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

export const formatPercent = (value: number | null): string =>
  value === null ? '—' : `${(value * 100).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`

export const formatMinutes = (minutes: number | null): string => {
  if (minutes === null) return '—'
  if (minutes < 60) return `${minutes} min`
  const hours = minutes / 60
  if (hours < 48) return `${hours.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} h`
  return `${Math.round(hours / 24)} dias`
}
